import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "chat-widget",
    style: { "z-index": "9998" }
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = { class: "text-sm font-medium" };
const _hoisted_4 = {
    key: 0,
    class: "fixed flex flex-col bg-white shadow-2xl overflow-hidden bottom-0 right-0 w-screen h-screen sm:bottom-6 sm:right-6 sm:w-[380px] sm:h-[600px] sm:rounded-2xl md:w-[380px] md:h-[600px]"
};
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { IconMessageCircle } from '@tabler/icons-vue';
import ChatHeader from './ChatHeader.vue';
import ChatMessages from './ChatMessages.vue';
import ChatInput from './ChatInput.vue';
import DraftReviewModal from './DraftReviewModal.vue';
import { useChat } from '../composables/useChat';
import overlayService from '@/services/overlay-service';
import { createModalConfig } from '@/utils/overlay-utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatWidget',
    setup(__props) {
        const route = useRoute();
        const isConversationsPage = computed(() => route.path.includes('/conversations'));
        const { isOpen, isMinimized, messages, isTyping, streamingMessageId, quickActions, canCreateItineraries, shouldShowWelcome, shouldShowQuickActions, open, toggle, close, minimize, send, sendQuickAction, } = useChat();
        function handleSend(content) {
            send(content);
        }
        function handleQuickAction(action) {
            sendQuickAction(action);
        }
        function handleRetry(content) {
            send(content);
        }
        function handleOpenDraft(draft) {
            if (!canCreateItineraries.value)
                return;
            overlayService.open(createModalConfig({
                component: DraftReviewModal,
                size: "xl",
                props: { draft },
            }));
        }
        return (_ctx, _cache) => {
            return (!isConversationsPage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_Transition, { name: "fade-scale" }, {
                        default: _withCtx(() => [
                            (!_unref(isOpen) && !_unref(isMinimized))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "fixed flex items-center justify-center text-white transition-all rounded-full shadow-lg bottom-6 right-6 w-14 h-14 sm:w-16 sm:h-16 bg-eorange-500 hover:bg-eorange-600 hover:shadow-xl group",
                                    "aria-label": _ctx.$t('chatbot.auto.abrir_chat'),
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_unref(toggle) && _unref(toggle)(...args)))
                                }, [
                                    _createVNode(_unref(IconMessageCircle), {
                                        size: 28,
                                        class: "sm:hidden"
                                    }),
                                    _createVNode(_unref(IconMessageCircle), {
                                        size: 32,
                                        class: "hidden sm:block"
                                    }),
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "absolute top-0.5 right-0.5 w-3.5 h-3.5 bg-egreen-500 rounded-full border-2 border-white" }, null, -1))
                                ], 8, _hoisted_2))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_Transition, { name: "fade-scale" }, {
                        default: _withCtx(() => [
                            (_unref(isMinimized))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "fixed bottom-6 right-6 flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-eorange-500 to-eorange-400 text-white rounded-full shadow-lg hover:shadow-xl transition-all",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_unref(open) && _unref(open)(...args)))
                                }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-7 h-7 bg-white rounded-full flex items-center justify-center flex-shrink-0" }, [
                                        _createElementVNode("span", { class: "text-eorange-500 font-bold text-xs" }, "E")
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("chatbot.auto.asistente_emanta")), 1),
                                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "w-2 h-2 bg-egreen-400 rounded-full flex-shrink-0" }, null, -1))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_Transition, { name: "slide-up" }, {
                        default: _withCtx(() => [
                            (_unref(isOpen))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(ChatHeader, {
                                        "is-welcome": _unref(shouldShowWelcome),
                                        onClose: _unref(close),
                                        onMinimize: _unref(minimize)
                                    }, null, 8, ["is-welcome", "onClose", "onMinimize"]),
                                    _createVNode(ChatMessages, {
                                        messages: _unref(messages),
                                        "is-typing": _unref(isTyping),
                                        "streaming-message-id": _unref(streamingMessageId),
                                        "should-show-welcome": _unref(shouldShowWelcome),
                                        "should-show-quick-actions": _unref(shouldShowQuickActions),
                                        "quick-actions": _unref(quickActions),
                                        "can-create-itineraries": _unref(canCreateItineraries),
                                        onQuickAction: handleQuickAction,
                                        onOpenDraft: handleOpenDraft,
                                        onRetry: handleRetry
                                    }, null, 8, ["messages", "is-typing", "streaming-message-id", "should-show-welcome", "should-show-quick-actions", "quick-actions", "can-create-itineraries"]),
                                    _createVNode(ChatInput, { onSend: handleSend })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
